<template>
  <Result />
</template>

<script>

import Result from '@components/content/result.vue'

export default {
  components: {
    Result
  },
}
</script>

<style>


.form-control {
  font-size: 12px;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: left;
}

.tablestyle thead th {
  background: #37405A;
  color: #B0BFD3;
  font-weight: normal;
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4D4F5C;
}

.tablestyle .currency {
  text-align: right;
}


.tablestyle tbody tr td {}


.tablestyle tbody tr:nth-of-type(2n+0) td {
  background: #E3ECFE;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}

.pull-right {
  float: right;
}

.resulticon {
  margin: 0 auto;
  display: block;
  font-size: 10px;
  background-color: #999;
  text-align: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 18px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
  position: relative;
}

.o4,
.o1,
.o20,
.oa1,
.oa4,
.on5,
.om1,
.oh1,
.ohR,
.od1,
.od4,
.od8,
.omr2,
.omr6,
.oaw1,
.oaw4,
.oaw8,
.oaw12,
.oaw16,
.ob8,
.oaw20,
.oaw24,
.ob1 {
  background: rgb(250, 89, 79) !important;
}
.o2,
.o6,
.o19,
.oa6,
.om2,
.oh2,
.ohB,
.od3,
.od5,
.od9,
.omr3,
.omr7,
.oaw3,
.oaw5,
.oaw13,
.oaw21,
.ob3,
.ob9 {
  background: rgb(62, 127, 253) !important;
}

.o3,
.o11,
.oa3,
.o29,
.on6,
.od2,
.omr14,
.omr99,
.oaw2,
.oaw9,
.oaw17,
.oaw25,
.oaw0,
.ob2 {
  background: rgb(66, 74, 82) !important;
}

/* Black */

.o9,
.o17,
.o21,
.oa9,
.on2,
.om5,
.od7,
.od11,
.of2,
.omr5,
.omr9,
.oaw7,
.oaw15,
.oaw23 {
  background: rgb(111, 65, 24) !important;
}

/* Brown / Even */

.o7,
.oa7,
.o30,
.on1,
.om4,
.od6,
.od10,
.of1,
.omr4,
.omr8,
.oaw6,
.oaw14,
.oaw22 {
  background: rgb(246, 201, 100) !important;
}

/* Yellow / Odd */

.o10,
.oa10,
.omr13,
.oaw10,
.oaw18,
.oaw26 {
  background: rgb(92, 182, 164) !important;
}

/* LightGreen */

.o12,
.o18,
.oa12,
.omr12,
.oaw11,
.oaw19,
.oaw27 {
  background: rgb(47, 106, 93) !important;
}

/* DarkGreen */

.on3 {
  background: rgb(255, 136, 0) !important;
}

/*Number Over*/

.on4 {
  background: rgb(250, 89, 79) !important;
}

/*Number Under*/

.o28,
.omr11 {
  background: rgb(187, 55, 178) !important;
}

/* Pink */

.o31,
.omr10 {
  background: rgb(179, 64, 62) !important;
}

/* BrownRed */

.toggle-tooltip {
  display: none;
  position: absolute;
  height: auto;
  line-height: 25px;
  width: 48px;
  left: -15px;
  bottom: 20px;
  border-radius: 5px;
  background: #1C6ECA;
  color: #fff;
}

.toggle-tooltip:before {
  position: absolute;
  left: 19px;
  bottom: -5px;
  content: '';
  border-top: 6px solid #1C6ECA;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

span.resulticon:hover .toggle-tooltip {
  display: block;
}

.info-td {}

.info-td-o {
  text-align: center;
}

.info-td>span:first-child {
  width: 22px;
}

.info-td>span {
  display: inline-block;
  text-align: center;
  margin: 0 2px;
}

.filter-section {
  text-align: left;
  margin: 10px 0;
  overflow: hidden;
  height: 28px;
  width: 100%;
}

.filter-section-cont {
  padding-bottom: 17px;
  padding-right: 17px;
  width: 100%;
  height: 45px;
  /* overflow-x: scroll; */
}

.filter-section center {
  text-decoration: underline;
}

.filter-section-cont div {
  margin: 0 3px;
  line-height: 28px;
  height: 28px;
  float: left;
  cursor: pointer;
}

.filter-section div input {
  display: none;
}

.filter-section div input {
  vertical-align: middle;
  margin-right: 3px;
}

.filter-section div span {
  line-height: 28px;
  height: 28px;
  font-size: 13px;
  border-radius: 28px;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  display: block;
  padding: 0 10px 0 30px;
  font-size: 12px;
  position: relative;
}

.filter-section div input:checked+span {
  background: #EC9D3C;
}

.filter-section div span:before {
  content: '';
  border: 1px solid #fff;
  height: 10px;
  width: 10px;
  border-radius: 10px;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.filter-section div input:checked+span:before {
  background: #fff;
}

body {
  background: #45464E url('/images/kenobg.jpg') no-repeat fixed;
  background-size: cover;
}

.top-navbar {
  text-align: center;
  background: #292A2E;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #4EBAF1;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #4EBAF1;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #4EBAF1;
  text-decoration: none;
}

.balancetxt>span {
  color: #4EBAF1;
}

.dotted {
  border-bottom: 1px dotted #fff;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.lrspan span {
  display: inline-block;
  width: 50%
}

.lrspan span:nth-child(1) {
  text-align: left;
}


.lrspan span:nth-child(2) {
  text-align: right;
}

.statement-card {
  color: #313A47;
  background: #fff;
  padding: 6px;
  border-radius: 4px;
  display: block;
  margin-top: 10px;
  font-weight: bold;
}

.statement-card:hover {
  color: #313A47;
}

/* .thefilter-container {
  background: #464243;
} */

#app{
 background: #45464E;
 font-size: 12px;
}

.showhidefilter {
  color: #fff;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  padding-right: 20px;
  position: relative;
}

.showhidefilter:hover {
  text-decoration: none;
  color: #4EBAF1;
}

.showhidefilter:after {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: initial;
  right: 5px;
  transform: rotate(45deg) translateY(-50%);
  transform-origin: top;
  top: 60%;
  transition: all .3s ease-out;
}

.showhidefilter.active:after {
  transform: rotate(-135deg) translateY(-50%);
  top: 50%;
}

.filter-title {
  text-align: left;
  margin: 5px 0 9px;
  color: #fff;
}

.select-class {
  height: 26px;
  line-height: 26px;
  background: #16284B;
  color: #4271AC;
  padding: 0;
  border-radius: 4px;
}

.submitbutt {
  display: block;
  width: 100%;
  height: 28px;
  line-height: 28px;
  background: #11487E;
  background: -moz-linear-gradient(left, #11487E 0%, #1D8AF2 100%);
  background: -webkit-linear-gradient(left, #11487E 0%, #1D8AF2 100%);
  background: linear-gradient(to right, #11487E 0%, #1D8AF2 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#11487E', endColorstr='#1D8AF2', GradientType=1);
  color: #fff;
  border-radius: 4px;
  font-weight: bold;
}

.submitbutt:hover {
  color: inherit;
  text-decoration: none;
}

.select-dropdown {
  background: #4271AC;
  color: #fff;
}

.thefilter-container form {
  height: 0;
  overflow: hidden;
  transition: 0.3s all;
}

.thefilter-container.active form {
  height: 90px;
}

.page-link {
  color: #007bff;
}

.page-item.active .page-link {
  background-color: #11487E;
  border-color: #11487E;
}

@media print,
screen and (max-width: 640px) {
  .mobileoverflow {
      overflow: scroll;
  }
}
</style>

